import { useLexicalComposerContext } from '@lexical/react/LexicalComposerContext';
import { MarkdownShortcutPlugin } from '@lexical/react/LexicalMarkdownShortcutPlugin';
import { useMemo } from 'react';
import { createTransformers } from '../config/transformers';

export function MarkdownShortcutPluginWrapper() {
  const [editor] = useLexicalComposerContext();
  const transformers = useMemo(() => createTransformers(editor), [editor]);

  return <MarkdownShortcutPlugin transformers={transformers} />;
}
